module.exports = {"440825001":"徐城街道办","440825102":"迈陈镇","440825103":"海安镇","440825104":"曲界镇","440825105":"前山镇","440825106":"西连镇","440825107":"下桥镇","440825108":"龙塘镇","440825109":"下洋镇","440825110":"锦和镇","440825111":"和安镇","440825112":"新寮镇","440825113":"南山镇","440825201":"城北乡","440825204":"角尾乡","440825451":"南华农场","440825452":"五一农场","440825453":"华海公司","440825454":"友好农场","440825455":"红星农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440825.json
// module id = 2002
// module chunks = 0